

import React from 'react';

const AddItem = () => {
    return (
        <svg width="28" height="26" viewBox="0 0 28 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1H5.57143L8.63428 16.3029C8.73879 16.829 9.02504 17.3017 9.44291 17.6381C9.86078 17.9744 10.3837 18.1531 10.92 18.1429H22.0286C22.5649 18.1531 23.0878 17.9744 23.5057 17.6381C23.9235 17.3017 24.2098 16.829 24.3143 16.3029L26.1429 6.71429H6.71429M16.5 10V15M14 12.5H19M11.2857 23.8572C11.2857 24.4883 10.774 25 10.1429 25C9.51167 25 9 24.4883 9 23.8572C9 23.226 9.51167 22.7143 10.1429 22.7143C10.774 22.7143 11.2857 23.226 11.2857 23.8572ZM23.857 23.8572C23.857 24.4883 23.3453 25 22.7141 25C22.083 25 21.5713 24.4883 21.5713 23.8572C21.5713 23.226 22.083 22.7143 22.7141 22.7143C23.3453 22.7143 23.857 23.226 23.857 23.8572Z" stroke="#D6E1EF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default AddItem;
